import React, { SVGProps } from 'react';

const BlogIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="BlogIcon">
    <path
      d="M15.5 5.667v10.827a.832.832 0 0 1-.828.84H1.327a.827.827 0 0 1-.827-.827V1.493c0-.447.374-.826.835-.826h9.163l5.002 5Zm-1.667.833H9.667V2.333h-7.5v13.334h11.666V6.5ZM4.667 4.833h2.5V6.5h-2.5V4.833Zm0 3.334h6.666v1.666H4.667V8.167Zm0 3.333h6.666v1.667H4.667V11.5Z"
      fill="var(--dropdownIconColor)"
      stroke="var(--walletMenuBackground)"
      strokeWidth={0.6}
    />
  </svg>
);

export default BlogIcon;
